import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class BrowserWidthService {
  width: Observable<any>;
  modalActive$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  disableBackground$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    let windowSize$ = new BehaviorSubject(this.getDisplayMode());
    this.width = (windowSize$.pluck('width') as Observable<
      any
    >).distinctUntilChanged();
    Observable.fromEvent(window, 'resize')
      .map(this.getDisplayMode)
      .subscribe(windowSize$);
  }

  getDisplayMode() {
    let a = { innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 };
    a.innerHeight = window.innerHeight;
    a.innerWidth = window.innerWidth;
    a.outerHeight = window.outerHeight;
    a.outerWidth = window.outerWidth;

    return {
      width: a
    };
  }

  get mobileNavStatus(): boolean {
    return window.innerWidth < 769 ? true : false;
    // return window.innerWidth < 1025 ? true : false;
  }

  get tabletNavStatus(): boolean {
    return window.innerWidth > 768 && window.innerWidth < 1025 ? true : false;
  }

  get desktopStatus(): boolean {
    return window.innerWidth > 1025 ? true : false;
  }

  get isPhone(): boolean {
    return window.innerWidth < 800;
  }

  get isTablet(): boolean {
    return window.innerWidth > 799 && window.innerWidth < 1520;
  }

  get isDesktop(): boolean {
    return window.innerWidth > 1519;
  }

  get tabletButtonStyle(): Object {
    const bw = this.isIe
      ? this.getDisplayMode().width.innerWidth
      : this.getDisplayMode().width.innerWidth - 180;

    if (bw > 799 && bw < 1520) {
      return {
        width: bw / 4 < 231 ? '231px' : `${bw / 4}px`,
        display: 'flex',
        'justify-content': 'center',
        'white-space': 'normal',
        height: '100%',
        'align-items': 'stretch',
        'flex-grow': 1
      };
    }
  }

  get tabletButtonInnerStyle(): Object {
    const bw = this.isIe
      ? this.getDisplayMode().width.innerWidth
      : this.getDisplayMode().width.innerWidth - 180;

    if (bw > 799 && bw < 1520) {
      return {
        width: bw / 4 < 231 ? '231px' : `${bw / 4}px`,
        display: 'flex',
        'justify-content': 'center',
        'white-space': 'normal',
        height: '100%',
        'align-items': 'center',
        'flex-grow': 1
      };
    }
  }

  get isIe() {
    return (
      !!navigator.userAgent.match(/Trident/g) ||
      !!navigator.userAgent.match(/MSIE/g) ||
      !!navigator.userAgent.match(/Edge/g)
    );
  }

  get mobileButtonStyle(): any {
    let bw = this.getDisplayMode().width.innerWidth;
    if (bw < 769) {
      let obj = {
        width: `${bw - 82}px`,
        display: 'flex',
        'justify-content': 'center'
      };
      return obj;
    } else if (bw > 768 && bw < 1025) {
      let obj = {
        width: `${bw / 3 - 50}px`,
        display: 'flex',
        'justify-content': 'center'
      };
      return obj;
    } else {
      return {};
    }
  }

  get mobileModalStyle() {
    let bw = this.getDisplayMode().width.innerWidth;
    let bh = this.getDisplayMode().width.innerHeight;
    if (bw < 1025) {
      let obj = {
        'background-color': 'rgba(0, 0, 0, 0.25)',
        display: 'block',
        height: `${bh}px`,
        padding: '15px 30px',
        position: 'fixed',
        width: `${bw}px`,
        'z-index': 190,
        'padding-top': '105px !important',
        overflow: 'hidden',
        top: '0 !important',
        left: '0 !important'
      };
      return obj;
    } else {
      let obj = {
        'background-color': 'rgba(0, 0, 0, 0.25)',
        display: 'block',
        height: `${bh}px`,
        padding: '15px 30px',
        position: 'fixed',
        width: `${bw}px`,
        'z-index': 190,
        'padding-top': '105px !important',
        overflow: 'hidden',
        top: '0 !important',
        left: '0 !important'
      };
      return obj;
    }
  }

  setScroll(value: boolean) {
    if (value === true) {
      this.modalActive$.next(true);
    } else {
      this.modalActive$.next(false);
    }
  }

  get disableTab(): Observable<boolean> {
    return this.modalActive$;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/browser-width.service.ts